import React, { useEffect, useMemo, useState } from 'react';
import './InvestmentRecommendationDock.css';

const DUMMY_RECOMMENDATIONS = {
  sale: [
    { id: 's1', name: '센트럴파크뷰', area: '84A', price: '5.3억', badge: '추천 1순위', note: '역세권 + 학군' },
    { id: 's2', name: '리버하임', area: '59B', price: '4.1억', badge: '안정형', note: '전세수요 양호' },
    { id: 's3', name: '에코타운', area: '74', price: '4.8억', badge: '성장형', note: '재개발 수혜' },
    { id: 's4', name: '더포레', area: '84', price: '6.2억', badge: '프리미엄', note: '신축/대단지' },
    { id: 's5', name: '스카이시티', area: '101', price: '7.4억', badge: '고급형', note: '입지 우수' },
  ],
  lease: [
    { id: 'j1', name: '해밀하우스', area: '59A', price: '2.1억', badge: '전세 유망', note: '공실 리스크 낮음' },
    { id: 'j2', name: '메트로팰리스', area: '84', price: '2.9억', badge: '수요 안정', note: '교통 접근성' },
    { id: 'j3', name: '그린캐슬', area: '74', price: '2.6억', badge: '가성비', note: '학군 선호' },
    { id: 'j4', name: '시티웰', area: '84B', price: '3.1억', badge: '핵심지', note: '생활권 완성' },
    { id: 'j5', name: '루체하임', area: '59', price: '1.9억', badge: '회전형', note: '매물 소진 빠름' },
  ],
};

function InvestmentRecommendationDock() {
  const [mode, setMode] = useState('sale');
  const [isManualUnpinned, setIsManualUnpinned] = useState(false);
  const [isBottomReached, setIsBottomReached] = useState(false);
  const [unlockedIds, setUnlockedIds] = useState({});
  const [unlockingIds, setUnlockingIds] = useState({});

  useEffect(() => {
    const checkBottom = () => {
      const scrollTop = window.scrollY || window.pageYOffset || 0;
      const viewportBottom = scrollTop + window.innerHeight;
      const pageBottom = document.documentElement.scrollHeight;
      setIsBottomReached(viewportBottom >= pageBottom - 24);
    };

    checkBottom();
    window.addEventListener('scroll', checkBottom, { passive: true });
    window.addEventListener('resize', checkBottom);

    return () => {
      window.removeEventListener('scroll', checkBottom);
      window.removeEventListener('resize', checkBottom);
    };
  }, []);

  const cards = useMemo(() => DUMMY_RECOMMENDATIONS[mode] || [], [mode]);
  const isFixed = !isManualUnpinned && !isBottomReached;

  useEffect(() => {
    setUnlockedIds({});
    setUnlockingIds({});
  }, [mode]);

  const handleUnpin = () => {
    setIsManualUnpinned(true);
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
    });
  };

  const unlockCard = (cardId) => {
    if (unlockedIds[cardId] || unlockingIds[cardId]) {
      return;
    }

    setUnlockingIds((prev) => ({ ...prev, [cardId]: true }));
    window.setTimeout(() => {
      setUnlockedIds((prev) => ({ ...prev, [cardId]: true }));
      setUnlockingIds((prev) => {
        const next = { ...prev };
        delete next[cardId];
        return next;
      });
    }, 420);
  };

  return (
    <div className={`investment-dock-slot ${isFixed ? 'fixed-mode' : 'inline-mode'}`}>
      <section className={`investment-dock ${isFixed ? 'is-fixed' : 'is-inline'}`}>
        <div className="investment-dock-inner">
          <div className="investment-dock-head">
            <div className="investment-dock-title-wrap">
              <h4>이 단지 추천 매물</h4>
              <div className="investment-dock-segment">
                <button
                  type="button"
                  className={mode === 'sale' ? 'active' : ''}
                  onClick={() => setMode('sale')}
                >
                  매매
                </button>
                <button
                  type="button"
                  className={mode === 'lease' ? 'active' : ''}
                  onClick={() => setMode('lease')}
                >
                  전세
                </button>
              </div>
            </div>
            {isFixed ? (
              <button type="button" className="dock-close-btn" onClick={handleUnpin} aria-label="하단 고정 해제">
                ×
              </button>
            ) : null}
          </div>

          <div className="investment-card-row">
            {cards.map((card) => (
              <article
                key={card.id}
                className={`investment-card ${!unlockedIds[card.id] ? 'is-locked' : ''} ${unlockingIds[card.id] ? 'is-unlocking' : ''}`}
              >
                <div className="investment-card-body">
                  <div className="investment-card-top">
                    <span className="investment-badge">{card.badge}</span>
                    <button type="button" className="investment-detail-btn">상세보기</button>
                  </div>
                  <div className="investment-card-content">
                    <div className="investment-name">{card.name}</div>
                    <div className="investment-meta">{card.area} · {card.price}</div>
                    <div className="investment-note">{card.note}</div>
                  </div>
                </div>

                {!unlockedIds[card.id] ? (
                  <button
                    type="button"
                    className={`investment-lock-mask ${unlockingIds[card.id] ? 'is-unlocking' : ''}`}
                    onClick={() => unlockCard(card.id)}
                    disabled={!!unlockingIds[card.id]}
                  >
                    <span className="lock-icon" aria-hidden="true" />
                    <span>클릭해서 잠금 해제</span>
                  </button>
                ) : null}
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default InvestmentRecommendationDock;
